// import React from "react"
// import { Helmet } from "react-helmet"

// export const SEO = () => {
//   return (
//     <Helmet>
//       <title>VisualFolio</title>
//       <meta
//         name="description"
//         content="visualfolio is the best It services company in the world"
//       />
//       <meta name="image" content="/visualfolio.png" />
//       <meta property="og:image" content="/visualfolio.png"/>
//       <meta property="og:url" content="https://visual-folio.vercel.app" />
//       <meta property="og:type" content="website" />
//       <meta property="og:title" content="VisualFolio" />
//       <meta
//         property="og:description"
//         content="visualfolio is the best It services company in the world"
//       />
//       <meta property="og:image" content="https://visual-folio.vercel.app/visualfolio.png"/>
//       <meta property="og:image:width" content="420" />
//       <meta property="og:image:height" content="420" />
//     </Helmet>
//   )
// }

import React from "react"
import { useSiteMetadata } from "@hooks"

export const SEO = ({ title, description, children }: any) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    siteUrl,
  } = useSiteMetadata()

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image}`,
    url: `${siteUrl}`,
  }

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      {children}
    </>
  )
}
